"use client";

import { createContext, useState } from "react";

export const companySlugContext = createContext<{
  companySlug?: string;
  setCompanySlug: (companySlug: string) => void;
}>({
  companySlug: undefined,
  setCompanySlug: () => {},
});

export const CompanySlugProvider = ({
  children,
  companySlug,
}: {
  children: React.ReactNode;
  companySlug?: string;
}) => {
  const [companySlugTemp, setCompanySlugTemp] = useState(companySlug);
  return (
    <companySlugContext.Provider
      value={{
        companySlug: companySlugTemp,
        setCompanySlug: setCompanySlugTemp,
      }}
    >
      {children}
    </companySlugContext.Provider>
  );
};
